<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.77 26.78" style="width: 100%">
        <g id="Capa_2" data-name="Capa 2">
            <path class="cls-1"
                  d="M39.76,2.62C35-.24,26.23-.85,19.91,1.25,14.65,3,7.23,2.62,3,.4A2,2,0,0,0,1,.47,2,2,0,0,0,0,2.23V22.39a2.07,2.07,0,0,0,1,1.78c2.89,1.71,7.17,2.61,11.5,2.61a27.1,27.1,0,0,0,8.36-1.24c5.25-1.75,12.68-1.38,16.9.84a2.06,2.06,0,0,0,3-1.83V4.4A2.08,2.08,0,0,0,39.76,2.62ZM20.38,19.37a6,6,0,1,1,6-6A6,6,0,0,1,20.38,19.37Z"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "PayIcon"
}
</script>

<style scoped>
.cls-1 {
    fill: currentColor;
}
</style>
